import BulbPreload from '../core/bulbPreload';
import gsap from 'gsap'

class PageTransition {

    constructor()
    {
        this.bulbPreload = new BulbPreload()
        this.pageTransition = document.querySelectorAll('.pageTransition__overlay')
        this.imagesAlreadyLoaded  = []
        this.bulbPreload.on('progress', this.progressLoading.bind(this))
        this.bulbPreload.on('done', this.closeTransition.bind(this))
    }

    openTransition() {
        gsap.set(this.pageTransition, {opacity: 1})
        return new Promise((resolve) => {
            gsap.fromTo(this.pageTransition, {xPercent: -105,skewX: 5}, {
                xPercent: 0,
                skewX: 0,
                duration: 1.2,
                ease: 'expo.inOut',
                onComplete: () => {
                    resolve()
                }})
        })
    }

    loadAsset(htmlString)
    {
        let parser = new DOMParser();
        let doc = parser.parseFromString(htmlString, 'text/html');
        let images = doc.querySelectorAll('img[data-bulb-preload]');
        let imageToLoad = [];

        images.forEach((image) => {
            if (!this.imagesAlreadyLoaded.includes(image.src)) {
                imageToLoad.push(image);
                this.imagesAlreadyLoaded.push(image.src)
            }
        });
        if (imageToLoad.length > 0) {
            this.bulbPreload.loadImages(imageToLoad)
        } else {
            this.closeTransition()
        }

    }
    progressLoading(objPercent)
    {
        console.log(objPercent)
    }
    closeTransition() {
        gsap.to(this.pageTransition, {
            xPercent: 100,
            duration: 1.2,
            ease: 'expo.inOut',
          })

    }
}

export default PageTransition



// WEBPACK FOOTER //
// ./scripts/interface/pageTransition.js